import React from "react"
import { Box, Card, CardContent, IconButton, Stack, styled, Typography } from "@mui/material"
import LockOutlinedIcon from "@mui/icons-material/LockOutlined"
import { TabletStatus, TabletType } from "@models/company"
import { useResponsive } from "src/utils/useResponsive"

interface TabletRootProps {
  type: TabletType
}

const TabletRoot = styled(Card, { shouldForwardProp: (prop) => prop !== "open" })<TabletRootProps>(
  ({ theme, type }) => ({
    borderRadius: "50px",
    [theme.breakpoints.down("md")]: {
      borderRadius: "25px"
    },
    border: "3px solid #FFFFFF4C",
    "&:hover": {
      boxShadow: "0px 3px 30px #0000004D"
    },
    variants: [
      {
        props: (props: any) => props.onClick,
        style: {
          cursor: "pointer"
        }
      },
      {
        props: (props: any) => props.type === "KM",
        style: {
          background: "#28D6FF 0% 0% no-repeat padding-box",
          boxShadow: "3px 3px 10px #06478269"
        }
      },
      {
        props: (props: any) => props.type === "OUTSOURCING",
        style: {
          background: "#01294E 0% 0% no-repeat padding-box",
          boxShadow: "2px 2px 10px #06478269",
          border: "3px solid #1DD6FF",
          "& .MuiTypography-root": { color: "#20CBF6" },
          "& img": {
            filter: "invert(87%) sepia(22%) saturate(790%) hue-rotate(165deg) brightness(102%) contrast(101%)"
          }
        }
      },
      {
        props: (props: any) => props.type === "INSOURCING",
        style: {
          background: "#FFFFFF 0% 0% no-repeat padding-box",
          boxShadow: "3px 3px 10px #00000016",
          border: "3px solid #FFFFFF4C"
        }
      }
    ]
  })
)

interface TabletTileProps {
  imageSrc: string
  title: string
  type: TabletType
  status: TabletStatus
  small?: boolean
  onClick: () => void
}

export const TabletTile: React.FC<TabletTileProps> = ({
  imageSrc,
  title,
  type,
  status,
  onClick,
  small
}) => {
  const { isMobile } = useResponsive()
  return (
    <TabletRoot onClick={status === "INACTIVE" ? undefined : onClick} type={type}>
      <CardContent
        sx={{
          pt: { xs: 3, md: 8 },
          pb: { xs: 3, md: 0 },
          "&:last-child": {
            paddingBottom: { xs: 2, md: 4 }
          }
        }}
      >
        <Stack
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            height: {
              xs: "auto",
              md: small ? "160px" : "200px",
              lg: small ? "160px" : "220px"
            }
          }}
        >
          <Box
            component={"img"}
            src={imageSrc}
            alt=""
            sx={{
              width: {
                xs: "60px",
                md: small ? "100px" : "120px",
                lg: small ? "100px" : "130px"
              }
            }}
          />
          <Typography
            sx={{
              textAlign: "center",
              maxWidth: "90%",
              typography: {
                xs: "body1",
                md: "h5",
                lg: small ? "h5" : "h4"
              },
              fontWeight: {
                xs: 500,
                md: 500,
                lg: 500
              },
              mt: {
                xs: 1,
                md: 0
              }
            }}
          >
            {isMobile ? title.split(" ")[1] || title : title}
          </Typography>
        </Stack>
      </CardContent>
    </TabletRoot>
  )
}
